import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Packages
import MaskedTextInput from 'react-text-mask';

class ReduxMaskedFormInput extends Component {
  static propTypes = {
    // From Redux Form:
    // { input, label, type, meta: { touched, error } }

    // Required
    input: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,

    //Optional
    error: PropTypes.string,
    label: PropTypes.string,
    optionalClasses: PropTypes.string,
    placeholder: PropTypes.string,
    meta: PropTypes.object,
    handleInputRemoval: PropTypes.func,
    disabled: PropTypes.bool,
  }

  renderLabel(label) {
    const { disabled } = this.props;

    return label
    ? (
        <label className={disabled ? 'disabled' : null}>
          {label}
        </label>
      )
    : ''
  }

  handleRemoveButtonClick = (event) => {
    event.preventDefault();
    this.props.handleInputRemoval();
  }

  renderRemoveButton() {
    const { handleInputRemoval } = this.props;
    return handleInputRemoval
    ? (
      <a className="input-delete-button" onClick={(event)=> this.handleRemoveButtonClick(event)}>
        <svg className="icon"><use xlinkHref="#trash-can" /></svg>
      </a>
    ) : null
  }

  render() {
    const {
      guide,
      mask,
      placeholderChar,
      name,
      input: {
        value,
        onChange
      },
      label,
      meta: {
        touched,
        error
      },
      placeholder,
      type,
      optionalClasses,
    } = this.props

    return (
      <div
        className={`input-container${optionalClasses ? ' ' + optionalClasses : ''}${touched && error ? ' error' : ''}`}
      >
        {this.renderLabel(label)}
        <MaskedTextInput
          guide={guide}
          mask={mask}
          name={name}
          placeholder={placeholder}
          placeholderChar={placeholderChar}
          type={type}
          value={value}
          onChange={onChange}
        />
        {touched && error &&
          <div className="input-error-message">
            {error}
          </div>
        }
      </div>
    )
  }
}


export default ReduxMaskedFormInput;



// WEBPACK FOOTER //
// ./src/components/Global/ReduxForms/ReduxMaskedFormInput.js